import { colors } from "src/theme/colors";
import { line, seriesTone, withAlpha } from "src/theme/ui";

/**
 * What the TradingView widgets are told to look like.
 *
 * Their markup is inside an iframe on another origin, so no stylesheet of
 * ours can reach it — the embed config is the only lever there is. These are
 * the options it exposes, filled in from the product's own tokens rather
 * than from TradingView's defaults, and kept in one place because four
 * widgets sitting on one page disagreeing about grey is exactly how the page
 * looked before.
 *
 * What cannot be aligned: the type. These embeds take no font option, so the
 * widgets keep their own face. Everything that CAN be set is set.
 */

/**
 * No slab of their own.
 *
 * Every widget painted its own white background inside our white card — the
 * same surface drawn twice, with the widget's corners squared off inside the
 * card's rounded ones. Transparent, they sit on the card instead of on top
 * of it.
 */
export const TV_TRANSPARENT = true;

export const TV_COMMON = {
  colorTheme: "light" as const,
  isTransparent: TV_TRANSPARENT,
  locale: "en",
};

/**
 * The line colours on the watchlist's sparklines.
 *
 * They were `rgba(41, 98, 255, 1)` — TradingView's blue — for BOTH the
 * growing and the falling case, with a blue wash under either. That is wrong
 * twice over: it is not this product's accent, and one colour for up and
 * down throws away the only thing a sparkline that small can say. They take
 * the pair the product's own sparklines use, so a rising line means the same
 * thing on this page as on every other.
 */
export const TV_CHART_COLORS = {
  plotLineColorGrowing: seriesTone.up,
  plotLineColorFalling: seriesTone.down,
  belowLineFillColorGrowing: withAlpha(seriesTone.up, 0.12),
  belowLineFillColorFalling: withAlpha(seriesTone.down, 0.12),
  gridLineColor: line.hairline,
  scaleFontColor: colors.gray[500],
  /* The row a reader has selected, in a tint of our accent rather than
     TradingView's. */
  symbolActiveColor: withAlpha(colors.primary[500], 0.1),
};
